<template>
  <el-form :model="form" ref="form" class="data-card">
    <div class="data-card__header">
      <div class="d-flex align-items-baseline flex-wrap">
        <h3 class="my-0 mr-3">Заказ отменен</h3>
      </div>
    </div>

    <div class="mt-3">
      <el-form-item prop="reasonId">
        <el-select v-model="form.reasonId" filterable class="w-100" size="medium" disabled ref="reasonIdRef"
                   :loading="fetchCancellationReasonsProgress" placeholder="">
          <el-option v-for="option in cancellationReasons" :key="option.id" :label="option.displayName" :value="option.id" />
        </el-select>
        <span class="floating-span"
              :class="{'floating-span_active': $notEmpty(form.reasonId) || $notEmpty($refs.reasonIdRef && $refs.reasonIdRef.query)}">
          Причина отмены
        </span>
      </el-form-item>
    </div>

    <el-form-item prop="comment" class="mt-3">
      <el-input type="textarea"
                :rows="4"
                maxlength="200"
                show-word-limit
                v-model="form.comment"
                disabled
                resize="none"/>
      <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.comment) }">Комментарий</span>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    form: {
      reasonId: null,
      comment: '',
    },
  }),
  computed: {
    ...mapGetters({
      item: 'orders/item',
      cancellationReasons: 'orderCancellationReasonsDrop/items',
      fetchCancellationReasonsProgress: 'orderCancellationReasons/fetchProgress',
    }),
    cancellationData() {
      return this.item.visitOrderCancellationReason;
    },
  },
  methods: {
    ...mapActions({
      fetchCancellationReasons: 'orderCancellationReasonsDrop/fetchItems',
    }),
    fillForm() {
      if (this.cancellationData) {
        this.form.reasonId = this.cancellationData.reasonId;
        this.form.comment = this.cancellationData.customerComment;
      } else {
        this.form.reasonId = null;
        this.form.comment = '';
      }
    },
  },
  created() {
    this.fetchCancellationReasons();
    this.fillForm();
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
